import themeColors from '@/assets/theme/colors'

const classes = {
  mainDiv: {
    display: 'flex',
    justifyContent: 'center'
  },
  sndDiv: {
    maxWidth: 800,
    padding: '1.25rem'
  },
  h1: {
    marginTop: '2rem',
    marginBottom: '2.5rem',
    color: themeColors.gray.dark
  },
  h2: {
    marginTop: '1.25rem',
    marginBottom: '1rem',
    color: themeColors.gray.mid
  },
  b1: {
    fontSize: '0.93rem',
    color: themeColors.gray.mid
  },
  b2: {
    fontSize: '0.93rem',
    color: themeColors.gray.mid,
    marginBottom: '1.875rem'
  },
  b3: {
    fontSize: '0.93rem',
    color: themeColors.bg.start,
    marginBottom: '1.875rem',
    fontWeight: 600
  },
  ml: {
    marginLeft: '1rem'
  },
  itemTitle: {
    fontSize: '0.93rem',
    color: themeColors.info.main,
    fontWeight: 600
  },
  typoLink: {
    textDecoration: 'none'
  }
}

export default classes
